import { CSSResultArray } from 'lit';
import style from './mc-menu.scss';
export const styles: CSSResultArray = [style];
